import { Component, OnInit, EventEmitter, Output  } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { ApiCallerService } from '../services/api-caller.service';
import {AngularFireDatabase} from 'angularfire2/database';

@Component({
  selector: 'app-active-users-view',
  templateUrl: './active-users-view.component.html',
  styleUrls: ['./active-users-view.component.css']
})
export class ActiveUsersViewComponent implements OnInit {

	connected = 0;
	totalConnects = 0;
	totalDisConnects = 0;
	answered = 0;
	sessionCode = "";


	constructor(
		private service: ApiCallerService,
		private db: AngularFireDatabase) { }


	calculateConnects(){
		this.connected = this.totalConnects - this.totalDisConnects;
	}

	ngOnInit() {

		this.sessionCode = this.service.sessionCode; 
		 this.db.list('/Session-'+ this.service.sessionCode + "/connected").valueChanges().subscribe((session: any) => {
		    this.totalConnects = session.length;
		    this.calculateConnects();
		  });


		 this.db.list('/Session-'+ this.service.sessionCode + "/disconnected").valueChanges().subscribe((disconnects: any) => {
		    this.totalDisConnects = disconnects.length;
		    this.calculateConnects();
		  });

		 this.db.list('/Session-'+ this.service.sessionCode + "/currentAnswer").valueChanges().subscribe((totalAnswers: any) => {
		    this.answered = totalAnswers.length;
		  });

	}

}
